import Cookies from 'js-cookie';

export const createCookie = (name: string, value: string, days: number) => {
    Cookies.set(name, value, {
        expires: days,
        secure: true,
        path: '/',
        sameSite: 'Strict'
    });
};

export const deleteCookie = (name: string) => {
    Cookies.remove(name, {
        path: '/',
        sameSite: 'Strict'
    });
};

export const getCurrentCookieDomain = (hostname: string) => {
  var hostNameAsArray = hostname.split('.');
  const hostlength = hostNameAsArray.length;

  // Special case for domains that does not start with www' or 't-www / www-t'. Like skagenfondene.no and localhost
  if (
    hostlength > 1 &&
    hostNameAsArray[0] !== 'www' &&
    hostNameAsArray[0] !== 't-www' &&
    hostNameAsArray[0] !== 'www-t' &&
    hostNameAsArray[0] !== 'investor' &&
    hostNameAsArray[0] !== 'test-investor'
  ) {
    return '.' + hostname;
  }

  // Special case for domains with length 4 like www.skagenfunds.co.uk
  if (hostlength === 4) {
    return (
      '.' +
      hostNameAsArray[1] +
      '.' +
      hostNameAsArray[2] +
      '.' +
      hostNameAsArray[3]
    );
  }

  // For domains like www.skagenfondene.no or skagenfondene.no with lengt between 2 and 3
  if (hostlength === 2 || hostlength === 3) {
    return (
      '.' +
      hostNameAsArray[hostlength - 2] +
      '.' +
      hostNameAsArray[hostlength - 1]
    );
  }
  // For localhost
  return hostname;
};
